<template>
  <v-container
    id="painelprincipal-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div v-if="!paginaEnable">
      <h1 style="display: none">
        Usuário não tem permissão a essa página não existente
      </h1>
    </div>
    <div v-else>
      <v-row>
        <v-col
          cols="12"
          class="container"
        >
          <dashboard-filtro-datas
            :primeiro="enablePrimeiroDia"
            :ultimo="enableUltimoDia"
            :empresas="enableEmpresa"
            :url="link"
          />
          <show-movimentacao-saldo-bancario />
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="8"
              lg="8"
            >
              <show-movimentacao-saldo-semanal />
              <show-relatorio-anterior />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="4"
              lg="4"
            >
              <show-jutificativa-movimentacao />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardFluxoCaixa',
    emits: ['updateFluxo', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      ShowMovimentacaoSaldoBancario: () => import('../../components/financeiro/fluxoCaixaNativile/FluxoCaixaMovimentacaoSaldoContas'),
      ShowMovimentacaoSaldoSemanal: () => import('../../components/financeiro/fluxoCaixaNativile/FluxoCaixaMovimentacaoContasSemanal'),
      ShowJutificativaMovimentacao: () => import('../../components/financeiro/fluxoCaixaNativile/FluxoCaixaJustificativaMovimentacaoContas'),
      ShowRelatorioAnterior: () => import('../../components/financeiro/fluxoCaixaNativile/FluxoCaixaRelatorioAnterior'),
    },
    mixins: [utils],
    data: () => ({
      attrs: '',
      on: '',
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      usuarioIdentificado: false,
      paginaEnable: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enablePrimeiroDia: false,
      enableUltimoDia: false,
      enableEmpresa: true,
      link: window.location.href,
      permissaoFluxoCaixa: '',
      select: [],
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.primeiroDia)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      eventEmit.$emit('atualizar_texto', 'Fluxo de Caixa')

      Permissao.verificarPermissaoPaginaUsuario(localStorage.username, window.location.href, localStorage.tokencontrato).then(resposta => {
        if (resposta.data.status) {
          this.paginaEnable = true
        } else {
          this.$router.push('/dashboard')
        }
      }).catch(e => {
        if (e.message === 'Network Error') {
          this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
        }
      })

      Permissao.showPermissaoPagina(localStorage.username, window.location.href, localStorage.tokencontrato).then(resposta => {
        if (resposta.data.status) {
          this.permissaoFluxoCaixa = resposta.data.permissao

          if (this.$store.state.versao < resposta.data.versao) {
            this.$router.go()
          }

          if (this.permissaoFluxoCaixa === 'Usuário') {
            this.date = this.dateFormatted
            this.primeiroDia = this.date
          }
        }
      }).catch(e => {
        if (e.message === 'Network Error') {
          this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
        } else if (e.message === 'Permissão para a pagina não encontrada, metodo 8') {
          this.$router.push('/dashboard')
        }
      })

      if (localStorage.usuarioIdentificado) {
        this.usuarioIdentificado = true
        localStorage.removeItem('userUsername')
        localStorage.removeItem('userId')
        localStorage.removeItem('permissaoGestaoComercial')
        localStorage.removeItem('permissaoVenda')
        localStorage.removeItem('permissaoPedidos')
        localStorage.removeItem('permissaoTime')
        localStorage.removeItem('enableClientes')
        localStorage.removeItem('enableContasPagar')
        localStorage.removeItem('enableContasReceber')

        localStorage.setItem('paginaAtual', '/fluxocaixa')
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select) {
        this.select = select

        this.updateDate()
      },

      updateDate () {
        eventEmit.$emit('update-fluxo', this.select)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      align-items: center;
      height: 100px;
    }

    #formaterDados {
      font-size: 11px;
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #formaterDados {
      font-size: 11px;
    }
  }
</style>

<style lang="sass">
  #formaterDados
    font-size: 11px

</style>
